import {
    ApiHandlerNoParameter,
    createHandlerChainRunnerOptionalParameter,
} from "@insite/client-framework/HandlerCreator";
import { getTaxExemptStatus } from "@SupplyLand/Services/TaxCertificateService";
import { CustomActions } from "@SupplyLand/Store/Data/TaxExempt/TaxExemptReducer";
import { TaxExemptModel } from "@SupplyLand/Types/TaxExemptModels";
import { DispatchProp } from "react-redux";

type Props = DispatchProp<CustomActions>;
type HandlerType = ApiHandlerNoParameter<TaxExemptModel, Props>;

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await getTaxExemptStatus();
};

export const DispatchCompleteLoadTaxExemptStatus: HandlerType = props => {
    props.dispatch({
        type: "Data/TaxExempt/CompleteLoadTaxExemptStatus",
        result: props.apiResult,
    });
};

export const chain = [RequestDataFromApi, DispatchCompleteLoadTaxExemptStatus];

const loadTaxExemptStatus = createHandlerChainRunnerOptionalParameter(chain, {}, "LoadTaxExemptStatus");
export default loadTaxExemptStatus;
